module.exports = "/Public/build/059664639a7e8f561d125bbd1500c583.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorMenu/cross.svg
// module id = 836
// module chunks = 0